export default {
  name: "TimeConverter",
  methods: {
    getNonMilitaryTime (time, transformUppercase) {
      const hours = time.split(':')[0] > 12 ? `${(time.split(':')[0] - 12)}` : time.split(':')[0];
      let convertedHours = hours.toString()?.length === 1 ? `0${hours}` : hours; // added '0' in front of single number e.g. 9 => 09
      const minutes = time.split(':')[1];
      let timeSuffix = time.substring(0,2) > 11 ? 'Pm' : 'Am';
      if (hours === '00') {
        convertedHours = 12;
        timeSuffix = 'Am';
      }
      const timeSuffixTransformed = transformUppercase ? timeSuffix.toUpperCase() : timeSuffix;
    
      return `${convertedHours}:${minutes} ${timeSuffixTransformed}`;
    }
  }
}
